export default {
  'common.more': 'Más',
  'common.fold': 'Plegable',
  'common.noData': 'Datos aún no disponibles',
  'common.success': 'Éxito de operación',
  'common.docTitle': 'BREAKER PART (HEBEI) MACHINERY TECHNOLOGY CO., LTD.'
}
